<template>
  <v-app>
    <v-app-bar app elevation="5" class="v-navigation-drawer--mini-variant">
      <v-img @click="$router.push({name:'Landing'})" max-height="100" max-width="200" src="@/assets/sp/logoo.jpg"/>
      <!-- <v-toolbar-title>Developers</v-toolbar-title> -->
      <v-spacer/>
      <v-btn v-if="$vuetify.breakpoint.smAndUp" text color="primary" href='https://sasapay.co.ke/' target="blank" class="mr-3">Home</v-btn>
      <v-btn color="error"  @click="$router.push({name:'Register'})">Register</v-btn> &nbsp;&nbsp;
      <v-btn color="error"  @click="$router.push({name:'Login'})">Sign In</v-btn>
    </v-app-bar>
    <v-main class="auth">
      <router-view />
    </v-main>
    <otpInput/>
    <loader />
  </v-app>
</template>

<script>
import {AuthService} from "../index";

export default {
  name: "authLayout",
  data: ()=>({
    drawer:false,
  }),
  components: {
    // AppFooter,
  },
  computed: {
    auth() {
      return AuthService;
    },
  }
};
</script>

<style scoped>
@import url('../styles/auth.css');
</style>
